import { useCallback, useEffect, useState } from 'react';

import { config } from 'components/pages/Epg/config';
import { MARGIN_BOTTOM } from 'components/pages/Epg/constans';

function usePrrogramsLineCombiner() {
  const [visible, setVissible] = useState(false);
  const channelObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        setVissible(entry.isIntersecting);
      });
    },
    {
      rootMargin: `${(config.channelLineHeight + MARGIN_BOTTOM) * 2}px 0px`,
    },
  );

  const ref = useCallback((node: any) => {
    if (node) {
      channelObserver.observe(node);
    }
  }, []);

  useEffect(() => {
    return () => {
      channelObserver.disconnect();
    };
  }, []);

  return { visible, ref };
}

export { usePrrogramsLineCombiner };
